var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('HeroSection'),_c('RecipesSection'),_c('IngredientSection'),_c('JoinusSection',{attrs:{"user":_vm.user}}),_c('AboutSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }